module.exports = " <div class=\"fullscreen h-full w-full-sm\" ng-class=fullscreenClass> <md-sidenav id=aside class=\"app-aside md-sidenav-left\" ng-class=\"{'folded': !fullyFolded}\" ui-view=aside@ md-component-id=aside> </md-sidenav> <div id=content class=app-content role=main ui-view=content@> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout-fullscreen-portfolio.html
// module id = 306
// module chunks = 0